import { useQuery } from '@tanstack/react-query'
import { supabaseRpc } from '@/lib/supabaseClient'
import { isRealtimeEnabled } from './subscriptions'

export type ActivityEventType =
  | 'photo_uploaded'
  | 'photo_optimized'
  | 'photo_processing_failed'
  | 'photo_processing_skipped'
  | 'contributor_joined'
  | 'drop_created'

export type ActivityLogEntry = {
  id: string
  eventType: ActivityEventType
  actorName: string | null
  metadata: Record<string, unknown>
  createdAt: string
  sessionId: string | null
}

type ActivityLogRow = {
  id: string
  event_type?: ActivityEventType
  eventType?: ActivityEventType
  actor_name?: string | null
  actorName?: string | null
  metadata?: Record<string, unknown> | null
  created_at?: string
  createdAt?: string
  session_id?: string | null
  sessionId?: string | null
}

function toActivityLogEntry(row: ActivityLogRow): ActivityLogEntry {
  return {
    id: row.id,
    eventType: row.event_type ?? row.eventType ?? 'drop_created',
    actorName: row.actor_name ?? row.actorName ?? null,
    metadata: row.metadata ?? {},
    createdAt: row.created_at ?? row.createdAt ?? '',
    sessionId: row.session_id ?? row.sessionId ?? null,
  }
}

export function useDropActivityQuery(dropId: string | undefined) {
  const query = useQuery({
    queryKey: ['activity', dropId],
    queryFn: () => supabaseRpc<ActivityLogRow[]>('list_drop_activity', { p_drop_id: dropId }),
    enabled: !!dropId,
    refetchInterval: isRealtimeEnabled() ? false : 30_000,
  })

  const activities = (query.data ?? []).map(toActivityLogEntry)
  return { ...query, activities }
}
